import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Sidebar {
  private isOpenSignal = signal(false);

  isOpen = this.isOpenSignal.asReadonly();

  toggle() {
    this.isOpenSignal.update((open) => !open);
  }

  open() {
    this.isOpenSignal.set(true);
  }

  close() {
    this.isOpenSignal.set(false);
  }
}
